import { Navigate } from 'react-router-dom'

function Home() {
  return <Navigate to="/salesOrder" />
}

export default Home
